var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, KeyboardArrowLeftIcon, KeyboardArrowRightIcon, styled, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
var chunk = function (a, n) { return __spreadArray([], __read(Array(Math.ceil(a.length / n))), false).map(function (_, i) { return a.slice(n * i, n + n * i); }); };
var IconButton = styled(Box)(function (_a) {
    var disabled = _a.disabled;
    return ({
        marginTop: -56,
        width: 48,
        height: 48,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: disabled ? 'RGBA(255, 255, 255, 0.26)' : 'white',
        backgroundColor: disabled ? 'RGBA(0, 0, 0, 0.26)' : 'RGBA(0, 0, 0, 0.56)',
        borderRadius: 24,
        cursor: disabled ? 'default' : 'pointer',
        flexShrink: 0,
        '& .MuiBox-root': {
            backgroundColor: 'transparent',
        },
    });
});
var Image = styled('img')(function (_a) {
    var selected = _a.selected;
    return ({
        width: 96,
        height: 96,
        objectFit: 'cover',
        cursor: 'pointer',
        boxSizing: 'border-box',
        border: "".concat(selected ? 'solid 5px RGB(76, 175, 80) ' : 'none'),
    });
});
var PhotoPage = function (_a) {
    var images = _a.images, index = _a.index, onSelected = _a.onSelected;
    var pre = Math.floor((window.innerWidth - 200) / 110);
    var maxPage = Math.ceil(images.length / pre);
    var _b = __read(useState(0), 2), page = _b[0], setPage = _b[1];
    var handleNext = function () {
        if (page < maxPage - 1)
            setPage(function (prevPage) { return prevPage + 1; });
    };
    var handleBack = function () {
        if (page > 0)
            setPage(function (prevPage) { return prevPage - 1; });
    };
    useEffect(function () {
        setPage(Math.floor(index / pre));
    }, [index, images, pre]);
    return (_jsxs(Box, __assign({ sx: { flexGrow: 1, display: 'flex', alignItems: 'center', px: 7 } }, { children: [_jsx(IconButton, __assign({ onClick: handleBack, disabled: page === 0 }, { children: _jsx(KeyboardArrowLeftIcon, {}) })), _jsx(Stack, __assign({ spacing: 1, direction: "row", sx: { height: 150, display: 'flex', justifyContent: 'center', flexGrow: 1, p: 2 } }, { children: chunk(images, pre)[page].map(function (_a, i) {
                    var key = _a.key, src = _a.src, title = _a.title;
                    return (_jsxs(Stack, __assign({ alignItems: "center", spacing: 1, onClick: function () { return onSelected === null || onSelected === void 0 ? void 0 : onSelected(src, i); } }, { children: [_jsx(Image, { src: src, selected: key === images[index].key }), _jsx(Typography, __assign({ sx: { width: 96, lineHeight: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, variant: "body2", color: "white" }, { children: title }))] }), key));
                }) })), _jsx(IconButton, __assign({ onClick: handleNext, disabled: page === maxPage - 1 }, { children: _jsx(KeyboardArrowRightIcon, {}) }))] })));
};
export default PhotoPage;
